var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 55.514,
    viewBox: "0 0 64 55.514",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_606",
    "data-name": "Union 606",
    d: "M5832.473,19118.512a1.25,1.25,0,0,1-1.327-1.328v-3.467a16.852,16.852,0,0,1,10.4-15.2l.271-.271-.271-.271a9.868,9.868,0,1,1,15.985-7.748,9.451,9.451,0,0,1-3.739,7.748l-.271.271.271.271c6.666,2.654,10.675,8.533,10.16,15.2v3.467a1.251,1.251,0,0,1-1.327,1.328Zm1.572-4.281v.814h27.473v-.543a13.535,13.535,0,0,0-13.6-13.871A13.7,13.7,0,0,0,5834.045,19114.23Zm7.208-23.732a6.665,6.665,0,1,0,6.665-6.666A6.59,6.59,0,0,0,5841.252,19090.5Zm-40.587,3.469a24.169,24.169,0,0,1,3.468-19.211,25.549,25.549,0,0,1,15.985-11.215,35.572,35.572,0,0,1,5.337-.543,25.805,25.805,0,0,1,19.209,9.076l-4.009,1.328a20.768,20.768,0,0,0-15.2-6.395,22.934,22.934,0,0,0-4.523.543,20.375,20.375,0,0,0-13.331,9.076,21.294,21.294,0,0,0-2.925,16.01,22.2,22.2,0,0,0,18.694,17.07l-2.683,3.738A25.453,25.453,0,0,1,5800.666,19093.967Zm14.17,3.736,8.806-8.8-.027-14.414h3.5v15.742l-9.591,9.619Z",
    transform: "translate(-5800 -19062.998)",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaveIcon);
export default __webpack_public_path__ + "static/media/leave_icon.9773e59b690d81dbc26446fe84fe516d.svg";
export { ForwardRef as ReactComponent };